import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [
  {
    path: "home",
    loadChildren: "./components/components.module#ComponentsModule",
    data: {
      breadCrumb: "Home",
      url: "",
      headerImgPath: "",
      skipBreadCrumb: true,
      hasCta: true,
      hasCarousel: true,
      title:
        "Mutual Funds Investment Online - SIP Investment | ITI MF Company India",
      meta:
        "ITI Mutual Fund provide different types of mutual funds in India, mutual fund calculators, Multi Cap Fund, Small Cap Fund, Long Term Equity Fund, Arbitrage Fund, Liquid Fund, etc. It is among India's leading mutual fund investment company.",
      keywords: "ITI mutual fund, mutual funds india, mutual funds, best mutual funds, mutual funds investment, sip investment, elss funds, best sip plans, best mutual fund, sip, mf"
    },
  },

  { path: "", redirectTo: "home", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
